import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitSelfDeterminationAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitSelfDeterminationAssessmentResultInput;
}>;


export type SubmitSelfDeterminationAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitSelfDeterminationAssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitSelfDeterminationAssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & SelfDeterminationAssessmentResultFragment
    )> }
  ) }
);

export type SelfDeterminationAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'CardioRespResult' } | { __typename: 'InbodyCompositionResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'PersonalCopingResult' } | { __typename: 'ProcessingSpeedResult' } | { __typename: 'SartResult' } | (
    { __typename: 'SelfDeterminationResult' }
    & SelfDeterminationAssessmentResultDataFragment
  ) | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } }
);

export type SelfDeterminationAssessmentResultDataFragment = (
  { __typename: 'SelfDeterminationResult' }
  & { surveys: Array<(
    { __typename: 'SelfDeterminationSurveyResult' }
    & Pick<SchemaTypes.SelfDeterminationSurveyResult, 'category' | 'question'>
    & { scoring: (
      { __typename: 'LikertScaleResult' }
      & Pick<SchemaTypes.LikertScaleResult, 'score' | 'total' | 'label'>
    ) }
  )>, categoryAverages: Array<(
    { __typename: 'SelfDeterminationCategoryAverage' }
    & Pick<SchemaTypes.SelfDeterminationCategoryAverage, 'category' | 'maximumPossibleScore' | 'averageScore'>
  )> }
);

export const SelfDeterminationAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SelfDeterminationAssessmentResultData on SelfDeterminationResult {
  surveys {
    category
    question
    scoring {
      score
      total
      label
    }
  }
  categoryAverages {
    category
    maximumPossibleScore
    averageScore
  }
}
    `;
export const SelfDeterminationAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment SelfDeterminationAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on SelfDeterminationResult {
      ...SelfDeterminationAssessmentResultData
    }
  }
  createdAt
}
    `;
export const SubmitSelfDeterminationAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitSelfDeterminationAssessmentResult($input: SubmitSelfDeterminationAssessmentResultInput!) {
  submitSelfDeterminationAssessmentResult(input: $input) {
    ... on SubmitSelfDeterminationAssessmentResultSuccessfulResponse {
      result {
        ...SelfDeterminationAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${SelfDeterminationAssessmentResultFragmentDoc}
${SelfDeterminationAssessmentResultDataFragmentDoc}`;
export type SubmitSelfDeterminationAssessmentResultMutationFn = Apollo.MutationFunction<SubmitSelfDeterminationAssessmentResultMutation, SubmitSelfDeterminationAssessmentResultMutationVariables>;

/**
 * __useSubmitSelfDeterminationAssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitSelfDeterminationAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSelfDeterminationAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSelfDeterminationAssessmentResultMutation, { data, loading, error }] = useSubmitSelfDeterminationAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSelfDeterminationAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSelfDeterminationAssessmentResultMutation, SubmitSelfDeterminationAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSelfDeterminationAssessmentResultMutation, SubmitSelfDeterminationAssessmentResultMutationVariables>(SubmitSelfDeterminationAssessmentResultDocument, options);
      }
export type SubmitSelfDeterminationAssessmentResultMutationHookResult = ReturnType<typeof useSubmitSelfDeterminationAssessmentResultMutation>;
export type SubmitSelfDeterminationAssessmentResultMutationResult = Apollo.MutationResult<SubmitSelfDeterminationAssessmentResultMutation>;
export type SubmitSelfDeterminationAssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitSelfDeterminationAssessmentResultMutation, SubmitSelfDeterminationAssessmentResultMutationVariables>;